import FullWidthCard from "./FullWidthCard";

export default FullWidthCard;

export { FullWidthCard };
